export default {
  methods: {
    getTypeQuestion(value) {
      let statut = '';
      switch (value) {
        case 'ent_chk_qcms':
          statut = 'Question a choix multiples';
          break;
        case 'ent_chk_qrms':
          statut = 'Question a réponse multiples';
          break;
        case 'ent_chk_qvfs':
          statut = 'Question Vrai/Faux';
          break;
        case 'ent_chk_qns':
          statut = 'Question réponse numérique';
          break;
        case 'ent_chk_qcs':
          statut = 'Question a réponse courte';
          break;
        case 'ent_chk_qls':
          statut = 'Question a réponse longue';
          break;
        case 'ent_chk_qrs':
          statut = 'Question a réponse sélectionnable';
          break;
      }
      return statut;
    },
    getQuestionTypeCodeUrl(value) {
      let statut = '';
      switch (value) {
        case 'ent_chk_qcms':
          statut = 'qcm';
          break;
        case 'ent_chk_qrms':
          statut = 'qrm';
          break;
        case 'ent_chk_qvfs':
          statut = 'qvf';
          break;
        case 'ent_chk_qns':
          statut = 'qrn';
          break;
        case 'ent_chk_qcs':
          statut = 'qrc';
          break;
        case 'ent_chk_qls':
          statut = 'qrl';
          break;
        case 'ent_chk_qrs':
          statut = 'qrs';
          break;
      }
      return statut;
    },
  },
};
